// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`. 
// The list of file replacements can be found in `angular.json`.
import { version} from '../../package.json'

export const environment = {
  production: false,
  Version: version,
  firebase : {
    apiKey: 'AIzaSyDJ_fvqh-gZb_Q4XGrUPakMF5BBgBkOAMU',
    authDomain: 'wtn-login-7ffe2.firebaseapp.com',
    databaseURL: 'https://wtn-login-7ffe2.firebaseio.com',
    projectId: 'wtn-login-7ffe2',
    storageBucket: 'wtn-login-7ffe2.appspot.com',
    messagingSenderId: '549343923239',
    appId: '1:549343923239:web:88fbea245b920c04b71202',
    measurementId: 'G-46ZGW17JS2'
  }
};
/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/dist/zone-error';  // Included with Angular CLI.
